import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Arquivo from '../../../../components/auth/diario/listar/form_arquivo'


function ArquivoDiarioScreen() {

    return (
        <Fragment>
            <Head titulo="Substituindo Arquivo - Diário Eletrônico" />
            <HeaderLogged />
            <Container>
               <Arquivo />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ArquivoDiarioScreen;